import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { NotificationService } from '@fitech-workspace/core-lib';
import { MasterDataApiService } from '../api/master-data-api.service';

@Injectable({
	providedIn: 'root',
})
export class FloorPlanService {
	private _sasMap: Map<number, string> = new Map();

	constructor(private _apiService: MasterDataApiService, private _notificationService: NotificationService) {}

	getSasUri(locationId: number, url: string): Observable<string> {
		const sasUri: string = this.getSasUriFromMemory(locationId, url);
		if (sasUri) {
			return of(sasUri);
		}

		return this.getSasUriFromApi(locationId, url);
	}

	private getSasUriFromMemory(locationId: number, url: string): string | null {
		if (this._sasMap.has(locationId) && this.checkExpiration(this._sasMap.get(locationId))) {
			return this._sasMap.get(locationId);
		}

		return null;
	}

	private getSasUriFromApi(locationId: number, url: string): Observable<string> {
		return this._apiService.getFloorPlanSasUri(locationId, url).pipe(
			tap((res: string) => {
				this._sasMap.set(locationId, res);
			})
		);
	}

	private checkExpiration(sasUri: string): boolean {
		const exp = /(se=\d{4}-\d{2}-\d{2})/;
		const dateNow: Date = new Date();

		const result: RegExpExecArray = exp.exec(sasUri);
		if (result) {
			const len: number = result[0].length;
			const dateExpirionStr = result[0].slice(-len + 3);
			const dateExirion = new Date(dateExpirionStr);
			return dateExirion > dateNow;
		}
		return false;
	}
}
